import { Link } from "react-router-dom";
import { useLocalization } from "../../hooks/useLocalization";
import { useLocalePath } from "../../hooks/useLocalePath";
import { useTeamInfo } from "../../hooks/useTeams";
import { TeamLogo } from "../shared/TeamLogo";
import { RoutePageMeta } from "../../seo/RoutePageMeta";
import { teamDescription } from "./constants";

export const TeamGrid: React.FC = () => {
  const teamInfos = useTeamInfo();
  const { strings, locale } = useLocalization();
  const { localized } = useLocalePath();
  const copy = strings.TEAMS;

  return (
    <div className="mt-48 min-h-screen">
      <RoutePageMeta page="TEAMS" />
      <section
        className="mx-auto flex w-[92%] max-w-[80rem] flex-col items-stretch justify-center text-left"
        aria-labelledby="teams-page-title"
      >
        <h1 id="teams-page-title" className="fh-title-page mb-3 w-full">
          {copy.TITLE}
        </h1>
        <p className="fh-body mb-8 w-full max-w-[40rem] text-white/72">{copy.DIRECTORY_SUBTITLE}</p>

        {teamInfos && teamInfos.length > 0 ? (
          <ul className="m-0 grid w-full list-none grid-cols-[repeat(auto-fill,minmax(16.5rem,1fr))] gap-5 p-0">
            {teamInfos.map((teamInfo) => {
              const description = teamDescription(teamInfo, locale);
              return (
                <li key={teamInfo.id}>
                  <Link
                    className="flex h-full flex-col gap-4 rounded-[var(--surface-card-radius)] border border-[var(--surface-card-border)] bg-[var(--surface-card-bg)] p-[1.35rem] text-inherit no-underline transition-[border-color,transform,background-color] duration-150 ease-in-out hover:-translate-y-0.5 hover:border-[rgba(28,152,217,0.55)] hover:bg-white/[0.04] focus-visible:-translate-y-0.5 focus-visible:border-[rgba(28,152,217,0.55)] focus-visible:bg-white/[0.04] focus-visible:outline-none"
                    to={localized(`/fpl/teams/${encodeURIComponent(teamInfo.id)}`)}
                    aria-label={copy.VIEW_TEAM.replace("{team}", teamInfo.name)}
                  >
                    <TeamLogo
                      teamId={teamInfo.id}
                      className="h-[4.5rem] w-[4.5rem] rounded-[0.85rem] border border-white/12 object-cover"
                      alt={`${teamInfo.name} logo`}
                      width={72}
                      height={72}
                      linkToTeam={false}
                    />
                    <div className="flex min-w-0 flex-1 flex-col gap-[0.55rem]">
                      <h2 className="fh-title-card">{teamInfo.name}</h2>
                      <p className="fh-body-sm line-clamp-3 flex-1">
                        {description || copy.NO_DESCRIPTION}
                      </p>
                      <span className="fh-title-eyebrow mt-[0.35rem]">{copy.VIEW_TEAM_SHORT}</span>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        ) : (
          <p>{copy.NO_TEAMS_TO_SHOW}</p>
        )}
      </section>
    </div>
  );
};
